export const OVERVIEW_BLOCKS_ICON_MAP: Record<string, string> = {
  faq: "circle-question",
  knowledge_base: "layer-group",
  user_guide: "book-open",
  data_and_integrations: "diagram",
  developer_api: "code",
};
